"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var module_1 = require("./module");
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.BranchButton = function (_a) {
    var children = _a.children, to = _a.to;
    var _b = react_1.useContext(module_1.ModuleContext), state = _b[0], dispatch = _b[1];
    var goto = react_1.useMemo(function () { return function () {
        dispatch(module_1.goToPath(to));
    }; }, [to]);
    return (react_1.default.createElement(creator_ui_1.Button, { width: "fit-content", alignSelf: "center", onClick: goto }, children));
};
exports.BranchButton.displayName = "BranchButton";
